/**
 * Function that extends the native details element to close when clicking outside or pressing the ESC key.
 * Default behavior of the details element is just to close when clicking on the summary element.
 * To add this custom behavior, it is necessary the respective data attributes:
 *  data-details-close-on-click-outside
 *  data-details-close-on-esc
 */

const detailsToBeClosedOnClickOutside = document.querySelectorAll('[data-details-close-on-click-outside]');
const detailsToBeClosedWhenEscPressed = document.querySelectorAll('[data-details-close-on-esc');

const closeDetails = (el) => {
    el.removeAttribute('open');
};

document.addEventListener('click', (event) => {
    detailsToBeClosedOnClickOutside.forEach((targetItem) => {
        const isClickInside = targetItem.contains(event.target);
        !isClickInside && closeDetails(targetItem);
    });
});

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' || event.keyCode === 27) {
        detailsToBeClosedWhenEscPressed.forEach((targetItem) => closeDetails(targetItem));
    }
});
